// mui
import { TableContainer, Table, TableBody, TableRow, TableCell, Box, Button, Typography, Stack } from '@mui/material';

import { ExpandLess as ExpandLessIcon, ExpandMore as ExpandMoreIcon } from '@mui/icons-material';

import { Flag } from '../index.js';

function FilterDescHeader({ filterDesc, open, onToggle }) {
    const showFlag = (index, desc) => {
        let code = desc.substring(1, 3);
        let remain = desc.substring(3, desc.length);
        let arr = [];
        arr.push(Flag(index, code));
        if (remain) {
            arr.push(showTypography(index + 1, remain, 0));
        }
        return arr;
    };

    const showTypography = (index, desc, ml) => {
        return (
            <Typography key={index} sx={{ fontSize: '14px', ml: `${ml}px` }}>
                {desc}
            </Typography>
        );
    };

    const showStringWithFlag = (key, desc) => {
        let splits = desc.split(/[\s]+/);
        return (
            <Stack key={key} direction='row' alignItems='center' justifyContent='flex-end' gap={1}>
                {splits.map((x, index) => (x.includes('^') ? showFlag(index, x) : showTypography(index, x, 0)))}
            </Stack>
        );
    };

    const showString = (desc) => {
        return (
            <Typography
                sx={{
                    fontSize: '14px',
                    width: '100%',
                    overflow: 'hidden',
                    textWrap: 'noWrap',
                    textOverflow: 'ellipsis',
                    textAlign: 'right',
                }}>
                {desc}
            </Typography>
        );
    };

    const showDesc = (key, desc) => {
        return desc.includes('^') ? showStringWithFlag(key, desc) : showString(desc);
    };

    return (
        <Box sx={{ borderBottom: '1px solid', borderColor: 'primary.dark' }}>
            <Button
                onClick={onToggle}
                fullWidth
                disableRipple
                endIcon={open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                sx={{
                    minHeight: '48px',
                    position: 'relative',
                    textTransform: 'none',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    '&:hover': { backgroundColor: 'transparent' },
                }}>
                <Box
                    sx={{
                        flex: 1,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'stretch',
                    }}>
                    {Object.keys(filterDesc).length === 0 && (
                        <Typography
                            variant='m_dialog_title'
                            sx={{
                                position: 'absolute',
                                fontSize: '14px',
                                left: '50%',
                                top: '50%',
                                transform: 'translate(-50%, -50%)',
                                textTransform: 'uppercase',
                                color: 'primary.main',
                                pointerEvents: 'none',
                                whiteSpace: 'nowrap',
                            }}>
                            Select Filters
                        </Typography>
                    )}
                    {Object.keys(filterDesc).length > 0 && (
                        <TableContainer sx={{ p: 1 }}>
                            <Table padding='checkbox' sx={{ width: '100%' }}>
                                <TableBody>
                                    {Object.keys(filterDesc).map((key) => (
                                        <TableRow key={key}>
                                            <TableCell
                                                sx={{
                                                    p: 0,
                                                    width: '22%',
                                                    fontSize: '14px',
                                                    borderBottom: 'none',
                                                    color: 'primary.main',
                                                }}>
                                                {key}{' '}
                                            </TableCell>
                                            <TableCell
                                                align='right'
                                                sx={{
                                                    p: 0,
                                                    width: '78%',
                                                    borderBottom: 'none',
                                                    color: 'primary.main',
                                                }}>
                                                {showDesc(key, filterDesc[key])}
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    )}
                </Box>
            </Button>
        </Box>
    );
}

export { FilterDescHeader };
